'use client';
import useOpenAiChat from '@elem/compPage/chat/core/components/chat-icon/useOpenAiChat';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import { useRef } from 'react';
import { langTxt } from '../../../lang';
import MicrosoftChatA from '../MicrosoftChat';
import { openCustonChatList } from '../MicrosoftChat/config';
import './index.scss';

const RightMicroChat = ({ payloadData, payloadReady, rightIconUrl }: any) => {
    const chatRef = useRef<any>({});
    const { locale = '' } = getLocal();
    const { handleOpenChat } = useOpenAiChat();
    const handleOpen = () => {
        if (openCustonChatList.includes(locale)) {
            handleOpenChat();
            return;
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'get_support',
            button_name: 'Support Chat Icon',
            __btn_id1: `MicrosoftChat`,
            __btn_id2: 'MicrosoftChat-icon',
            __btn_type: 'common',
        });
        typeof chatRef.current?.open === 'function' && chatRef.current?.open();
    };

    return (
        <section className={'widgets-RightMicroChat RightMicroChat GtmModuleData-btn-common gtm-fix-icon'} data-btn-id="gtm-fix-icon">
            <div className="right-chat-wrap">
                <div className="icon-box WidgetsItem-icon" onClick={handleOpen}>
                    <EcoImg className="icon-img" pc={rightIconUrl}></EcoImg>
                </div>
                <div className="tips-box">
                    <div className="tips-inner">
                        <span className="tips">{langTxt[locale as string]?.ask || langTxt['us']?.ask}</span>
                        <span className="rect"></span>
                    </div>
                </div>
            </div>

            {payloadReady && <MicrosoftChatA payloadData={payloadData} onReady={(chatApi) => (chatRef.current = chatApi)} />}
        </section>
    );
};

export default RightMicroChat;
